@if (divider()) {
  <div class="esn-faq-item__divider" aria-hidden="true"></div>
}
<h3 class="esn-faq-item__heading">
  <button
    type="button"
    class="esn-faq-item__question"
    [id]="buttonId"
    [attr.aria-expanded]="open()"
    [attr.aria-controls]="panelId"
    (click)="toggle()"
  >
    <span class="esn-faq-item__label">{{ question() }}</span>
    <esn-icon class="esn-faq-item__chevron" name="chevron-circle-down" [size]="20" />
  </button>
</h3>
<div class="esn-faq-item__collapse" [class.esn-faq-item__collapse--open]="open()">
  <div
    class="esn-faq-item__answer"
    role="region"
    [id]="panelId"
    [attr.aria-labelledby]="buttonId"
    [attr.inert]="open() ? null : ''"
  >
    <div class="esn-faq-item__panel">
      @if (answer()) {
        <p class="esn-faq-item__text">{{ answer() }}</p>
      }
      <ng-content />
    </div>
  </div>
</div>
